// Pathify
import { make } from 'vuex-pathify'
import axios from 'axios'

const state = {
  close: "You are about to quit and the information will not be saved. Are you sure you want to exit?",
  validation_add: "You have successfully added information",
  validation_update: "You have successfully updated information",
  confirm_deletion: "You have successfully deleted information",
  error_message: "An error has occured",
  no: "No",
  yes: "Yes, I confirm",
  ok: "Ok" ,
  confirmationMessageAdd: false,
  confirmationMessageUpdate: false,
  confirmationMessageDelete: false,
  errorMessage: false,
}

const mutations = {
  setConfirmationAdd(state, payload) {
   state.confirmationMessageAdd = payload;
  },
  setConfirmationUpdate(state, payload) {
   state.confirmationMessageUpdate = payload;
  },
  setConfirmationDelete(state, payload) {
   state.confirmationMessageDelete = payload;
  },
  setErrorMessage(state, payload) {
   state.errorMessage = payload;
  }
}

const getters = {
  close: state => {
    return state.close
  },
  validation_add: state => {
    return state.validation_add
  },
  validation_update: state => {
    return state.validation_update
  },
  confirm_deletion: state => {
    return state.confirm_deletion
  },
  error_message: state => {
    return state.error_message
  },
  no: state => {
    return state.no
  },
  yes: state => {
    return state.yes
  },
  ok: state => {
    return state.ok
  },
  confirmationMessageAdd: state => {
    return state.confirmationMessageAdd
  },
  confirmationMessageUpdate: state => {
    return state.confirmationMessageUpdate
  },
  confirmationMessageDelete: state => {
    return state.confirmationMessageDelete
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
